import { toStatisticNumber } from 'utils/statisticNumber';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import { api, apiUtils } from 'app/services';
import * as actions from 'app/actions';
import {
KBLoadingContainer,
KBAvatar,
KBRangeDate,
KBPopover,
KBTipsy } from
'components';
import * as selectors from 'app/selectors';
import { KBDropSelect } from 'components/plugins';
import dayjs from 'utils/dayjs';
import { InitialHighCharts } from 'components/mixins';
import { percent } from 'utils/kbUtil';
import { OPPORTUNITY_STATES } from 'app/constants';
import {
extendDefaultHighchartsConfig,
getStatisticInitialDate,
getInitialDate } from
'utils/kbData';

var StatisticCustomerStateHistory = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseLoadFromTo = this.parseLoadFromTo.bind(this);this._loadData = this._loadData.bind(this);this.parseJSON = this.parseJSON.bind(this);this.compare = this.compare.bind(this);this.parseHightChartData = this.parseHightChartData.bind(this);this.fillChart = this.fillChart.bind(this);this.selectCallBack = this.selectCallBack.bind(this);this._setFilters = this._setFilters.bind(this);this.changeDate = this.changeDate.bind(this);this.setMonthFilters = this.setMonthFilters.bind(this);}getInitialState()


  {
    const { from, to } = getStatisticInitialDate();
    return {
      filters: {
        from,
        to },

      dataOut: [],
      month: '' };

  }componentDidMount()
  {
    const { filters, dataOut } = this.state;
    let Highcharts = this.getHighcharts();
    let filtersMonths = dayjs(filters.to).diff(dayjs(filters.from), 'months');
    this.setState({
      month: filtersMonths });

    this._loadData(filters);
    this.renderChart(
    'Chart',
    extendDefaultHighchartsConfig({
      chart: {
        type: 'funnel',
        marginRight: 100,
        height: 400,
        animation: false,
        reflow: false },

      title: {
        text: null,
        x: -50 },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b> ({point.y:,.0f})',
            color:
            Highcharts.theme && Highcharts.theme.contrastTextColor ||
            'black',
            softConnector: true },

          neckWidth: '30%',
          neckHeight: '25%' } },


      legend: {
        enabled: false } }));



  }parseLoadFromTo(


  params, from, to) {
    delete params.from;
    delete params.to;

    params.start_date = from ? getInitialDate(from).initStartDateString : null;
    params.end_date = to ? getInitialDate(to).initEndDateString : null;

    return params;
  }_loadData(

  filters) {
    const { from, to } = filters;
    var params = {};

    // 判断日期
    params = this.parseLoadFromTo(params, from, to);

    api.getCustomerStateHistoryStatistic(params).then(({ json }) => {
      if (!json.statistic) {
        return;
      }
      this.parseJSON(json.statistic);
    });
  }parseJSON(

  json) {
    var contain = {};
    let dataOut = [];

    var array = json;

    array.forEach(t => {
      if (t.state == 'failed') {
        return;
      }
      dataOut.push([OPPORTUNITY_STATES[t.state], toStatisticNumber(t.customer_count)]);
    });

    dataOut.sort(this.compare);

    this.parseHightChartData(dataOut);
  }compare(

  a, b) {
    if (!a || !b || !a[1] || !b[1]) {
      return 0;
    }

    if (a[1] - b[1] > 0) {
      return -1;
    } else if (a[1] - b[1] < 0) {
      return 1;
    }

    return 0;
  }parseHightChartData(

  data) {
    let dt = {
      name: '数量',
      data };


    this.fillChart([dt]);
  }fillChart(

  dataOut) {
    this.setSerierDate(dataOut);
  }selectCallBack(

  data) {
    this._setFilters({
      location_ids: data.map(json => json.id).join(',') });

  }_setFilters(

  obj) {
    let newFilters = Object.assign({}, this.state.filters, obj);
    this.setState({
      filters: newFilters });

    this._loadData(newFilters);
  }changeDate(

  range) {
    this._setFilters(range);
    this.setState({
      month: '' });

  }setMonthFilters(

  num = 1) {
    var to = dayjs().toDate();
    var from = dayjs().
    subtract(num, 'months').
    toDate();

    this.setState({
      month: num });


    this._setFilters({
      from,
      to });

  }render()

  {
    const { filters, month } = this.state;
    const { from, to } = filters;
    return (
      <article>
        <div className="chart-title m-top-lg">
          <span>CRM客户漏斗图</span>
          <button className="bordered-btn-small" onClick={this.print}>
            <i className="iconfont icon-contract" />
            打印
          </button>
          <button className="bordered-btn-small" onClick={this.exportingExcel}>
            <i className="iconfont icon-EXCEL" />
            导出Excel
          </button>
        </div>
        <div className="m-bottom-sm">
          <KBRangeDate
          format="YYYY/MM/DD"
          from={from || ''}
          to={to || ''}
          callback={this.changeDate}
          leftNone={true} />

          <div className="time-filter">
            <button
            className={month == 1 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 1)}>

              1个月
            </button>
            <button
            className={month == 3 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 3)}>

              3个月
            </button>
            <button
            className={month == 6 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 6)}>

              6个月
            </button>
            <button
            className={month == 12 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 12)}>

              1年
            </button>
          </div>
        </div>
        <div
        ref={ref => { this.highcharts = ref; }}
        style={{ width: '100%', height: 400 }} />
      </article>);

  }};Object.assign(StatisticCustomerStateHistory.prototype, InitialHighCharts);


function mapStateToProps(state, props) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
StatisticCustomerStateHistory);
